import { render, staticRenderFns } from "./CakeNew.vue?vue&type=template&id=5ad52a8c&scoped=true&"
import script from "./CakeNew.vue?vue&type=script&lang=js&"
export * from "./CakeNew.vue?vue&type=script&lang=js&"
import style0 from "./CakeNew.vue?vue&type=style&index=0&id=5ad52a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad52a8c",
  null
  
)

export default component.exports